import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';
import { getAuthToken } from '../../utils/authStorage';

// const branchWiseData = [
//   { "branch": "Katubedda", "Karate": "100", "Krav Maga": "35", "BJJ": "25" },
//   { "branch": "Piliyandala", "Karate": "40", "Krav Maga": "10", "BJJ": "5" },
//   { "branch": "Hulumale", "Karate": "25", "Krav Maga": "5", "BJJ": "3" },
// ];

const formatAxisLabel = (value, maxLength = 12) => {
  if (!value) return '';
  return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
};

const BranchWiseMemberCount = () => {
  const [membersData, setMembersData] = useState([]);

  useEffect(() => {
    const fetchMembersData = async () => {
      try {
        const token = getAuthToken() || localStorage.getItem('token') || sessionStorage.getItem('token');
        const response = await axios.get(`${config.apiBaseUrl}/get_member_count_by_branch`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        setMembersData(response.data["member_count_by_branch"]);
        console.log('Members data:', membersData);
      } catch (error) {
        console.error('Failed to fetch members data:', error);
        toast.error('Failed to fetch members data');
      }
    };

    fetchMembersData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ width: '100%', height: { xs: 280, sm: 320, md: 340 }, minWidth: 0 }}>
      {membersData.length === 0 ? (
        <Typography variant="body2">No data available.</Typography>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={membersData} margin={{ top: 8, right: 12, left: -12, bottom: 8 }} barCategoryGap="24%">
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="branch_name"
              tick={{ fontSize: 12 }}
              interval={0}
              tickMargin={8}
              height={36}
              tickFormatter={(value) => formatAxisLabel(value)}
            />
            <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
            <Tooltip
              itemStyle={{ color: '#000' }}
              labelStyle={{ color: '#000' }}
              formatter={(value) => [value, 'Members']}
              labelFormatter={(label) => label}
              cursor={{ fill: 'rgba(52, 152, 219, 0.08)' }}
            />
            <Bar dataKey="member_count" name="Members" fill="#3498db" radius={[6, 6, 0, 0]} maxBarSize={42} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};

export default BranchWiseMemberCount;